var moment = require('moment');
var fromNow = v => moment(v).fromNow();

export default function (nga, admin) {

    return nga.dashboard()
        .addCollection(
            nga.collection(nga.entity('evaluations').identifier(nga.field('evaluation_id')))
                .title('Recent Evaluations')
                .perPage(10)
                .fields([
                    nga.field('date', 'date')
                        .format('shortDate')
                        .label('Date')
                        .sortable(false),
                    nga.field('activity_name', 'string')
                        .label('Activity')
                        .sortable(false),
                    nga.field('exercise_title', 'string')
                        .label('Title')
                        .sortable(false),
                    nga.field('property_name', 'string')
                        .label('Property')
                        .sortable(false),
                    nga.field('value_name', 'string')
                        .label('Value')
                        .sortable(false)
                ])
                .sortField('date')
                .sortDir('DESC')
                .order(1)
        )
        .addCollection(
            nga.collection(nga.entity('evaluations_grouped'))
                .title('Evaluations Summary (past 2 months)')
                .perPage(10)
                .fields([
                    nga.field('id')
                        .map(function truncate(value, entry) {
                            return entry['exercise_id'] + '_' + entry['value_id'];
                        })
                        .sortable(false)
                        .cssClasses(() => 'hide'),
                    nga.field('count_and_total')
                        .map((value, entry) => { return entry['count'] + '/' + entry['total']})
                        .label('Σ')
                        .sortable(false),
                    nga.field('perc', 'float')
                        .map((value, entry) => { return entry['count'] / entry['total'] * 100; })
                        .label('%')
                        .sortable(false)
                        .format('0.00'),
                    nga.field('value_name')
                        .label('Value')
                        .sortable(false),
                    nga.field('property_name')
                        .label('Property')
                        .sortable(false),
                    nga.field('exercise_title')
                        .label('Exercise')
                        .sortable(false),
                    nga.field('activity_name')
                        .label('Activity')
                        .sortable(false),
                ])
                .permanentFilters({ months: 2 })
                .sortField('total')
                .sortDir('DESC')
                .order(2)
        )
        .template(`
<div class="row dashboard-starter"></div>
<dashboard-summary></dashboard-summary>
<div class="row dashboard-content">
    <div class="col-lg-6">
        <div class="panel panel-default" ng-repeat="collection in dashboardController.collections | orderElement" ng-if="$even">
            <ma-dashboard-panel collection="collection" entries="dashboardController.entries[collection.name()]" datastore="dashboardController.datastore"></ma-dashboard-panel>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="panel panel-default" ng-repeat="collection in dashboardController.collections | orderElement" ng-if="$odd">
            <ma-dashboard-panel collection="collection" entries="dashboardController.entries[collection.name()]" datastore="dashboardController.datastore"></ma-dashboard-panel>
        </div>
    </div>
</div>
`);
}



// WEBPACK FOOTER //
// ./js/dashboard/config.js